import { useState } from 'react';
import { Button, ShareIosIcon } from '@eventbrite/marmalade';
import { useIntl } from 'react-intl';
import { ShareModal } from './ShareModal';
import type { OrganizerData } from '@/types/organizer';
import styles from './ShareProfile.module.scss';

interface Props {
  organizer: OrganizerData;
}

export function ShareProfile({ organizer }: Props) {
  const intl = useIntl();
  const [isShown, setIsShown] = useState(false);

  return (
    <>
      <div className={styles.shareSlot}>
        <Button
          variant="ghost"
          type="button"
          sizeVariant="medium"
          onClick={() => {
            setIsShown(true);
          }}
          aria-label={intl.formatMessage({
            id: 'Share organizer profile',
            defaultMessage: 'Share organizer profile',
          })}
        >
          <ShareIosIcon size="small" aria-hidden />
          <span className={styles.label}>
            {intl.formatMessage({ id: 'Share', defaultMessage: 'Share' })}
          </span>
        </Button>
      </div>
      <ShareModal isShown={isShown} onClose={() => setIsShown(false)} organizer={organizer} />
    </>
  );
}
